<template>
  <div>
    <b-form-group label-cols="2" horizontal label="예약 내용" class="mt-4">

      <b-form-group label-cols="2" label="예약매장">
        <p style="padding-top: 6px;" class="modalFontSize">{{bookingInfo.selectedStoreName}}</p>
      </b-form-group>

      <b-form-group label-cols="2" label="예약자명">
        <b-form-input class="modalFontSize" :plaintext="true" v-model="bookingInfo.guestName"/>
      </b-form-group>

      <b-form-group label-cols="2" label="연락처">
        <p style="padding-top: 6px;" class="modalFontSize">{{bookingInfo.phoneNumber.replace(/^(01[016789]{1}|02|0[3-9]{1}[0-9]{1})-?([0-9]{3,4})-?([0-9]{4})$/, "$1-$2-$3")}}</p>
      </b-form-group>

      <b-form-group label-cols="2" label="방문일">
        <p style="padding-top: 6px;" class="modalFontSize"> {{ this.$moment(bookingInfo.reservationDate).format('YYYY-MM-DD').toString() }}</p>
      </b-form-group>

      <b-form-group label-cols="2" label="방문시간">
        <p style="padding-top: 6px;" class="modalFontSize"> {{ bookingInfo.reservationTime.substr(0,5) }}</p>
      </b-form-group>

      <b-form-group label-cols="2" label="인원">
        <b-row>
          <p style="padding-left: 15px; margin: 0; width: 100%; padding-top: 5px" class="modalFontSize">성인 : {{ bookingInfo.adultCount }} 명</p>
          <p style="padding-left: 15px; margin: 0; width: 100%;" class="modalFontSize">소인 : {{ bookingInfo.childCount }} 명</p>
          <p style="padding-left: 15px; margin: 0; width: 100%;" class="modalFontSize">유아 : {{ bookingInfo.babyCount }} 명</p>


        </b-row>
      </b-form-group>

      <b-form-group label-cols="2" label="요청사항">
        <div>
          <pre style="padding-top: 6px; font-size: 0.85rem; line-height: 1.3rem; font-family: 'Nunito', sans-serif; ">{{ bookingInfo.wishComment }}</pre>
        </div>
      </b-form-group>

      <b-form-group>
        <b-button v-if="bookingInfo.bookingNo == '' && status == false" variant="primary" class="mr-1" @click="bookingComplete">예약하기</b-button>
        <b-button v-if="bookingInfo.bookingNo != '' || status == true" variant="primary" class="mr-1" @click="updateBooking">수정하기</b-button>
        <b-button variant="outline-primary" @click="hideModal" ref="hideModal">취소</b-button>
      </b-form-group>

      <div v-if="!bookingInfo.bookingListFlag">
      <b-form-group>
        ※ <a style="color:red;">{{bookingInfo.phoneNumber}}</a> 번호로 예약된 내역이 <a style="color:red;">{{bookingCount}}개</a> 있습니다.
      </b-form-group>

        <div>
          <b-form-checkbox v-model="status" @change="checkUpdate">예약을 수정합니다
          </b-form-checkbox>
        </div>

      <hr>



      <div class="vuetable forCheck">
      <b-table
        :items="checkItem"
        :fields="fields"
        head-variant="light"
        ref="general-table"
        class="vuetable"
        id="table-transition-example"
        align="center"
        primary-key="bookingNo"
        responsive
        show-empty
        empty-text="내역이 없습니다."
      >
        <template v-slot:cell(selected)="row" v-if="status == true">
          <b-form-radio name="setUpdateBookingNo" @change="setUpdateBookingNo(row.item.bookingNo)" size="sm"></b-form-radio>
        </template>

        <template v-slot:cell(headcount)="row">
          {{Number(row.item.adultHeadcount) + Number(row.item.childHeadcount) + Number(row.item.babyHeadcount)+'명' }}
        </template>


      </b-table>
      </div>
      </div>





    </b-form-group>
  </div>
</template>

<script>
import {alignTableCenter} from "@/utils";
import {mapGetters} from "vuex";
import api from '../../../constants/api'

export default {
  props: ['bookingInfo','listItem'],
  computed: {
    ...mapGetters(["currentUser", "siteName", "brandInfo"]),
  },
  mounted() {
    if(this.bookingInfo.bookingNo == ''){
    this.getBookingList()
    }
  },

  data(){
    return{
      fields:[
        {key:'selected', label:'선택'},
        {key:'reservationDate', label: "날짜", ...alignTableCenter},
        {key:'reservationTime', label: "시간", ...alignTableCenter},
        {key:'headcount', label: "인원", ...alignTableCenter},
      ],
      checkItem: [],
      bookingCount: 0,
      listFlag:false,
      status:false,
    }
  },

  methods: {
    getBookingList(){
      var item = [];

      if (this.currentUser.userRole == 'STORE_MANAGER') {
        var reqUrl = api.changeAPI(this.siteName,api.basicURL + api.order.freeBookingsListStr)
        var params = {phoneNumber: this.bookingInfo.phoneNumber}
      }
      if (this.currentUser.userRole == 'BRAND_ADMIN'){
        var reqUrl = api.changeAPI(this.siteName,api.basicURL + api.order.freeBookingsList)
        var params = {
          storeCode: this.bookingInfo.selectedStore,
          phoneNumber: this.bookingInfo.phoneNumber}
      }

      this.$http.post(reqUrl, params, {
        headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
      }).then(res =>{
        if(res.data.code === "OK"){
          res.data.data.bookings.forEach(val =>{
            if(val.changeable == true){
              item.push(val)
            }
          })
          this.checkItem = item
          this.bookingCount = item.length


        } else{
          throw 400
        }
      }).catch(err => {
        alert(err.response.data.message);
      })
    },
    updateBookingFromList(val){

      const reqUrl = api.changeAPI(this.siteName,api.basicURL + api.order.updateFreeBooking)
      var params = {
        bookingNo: val,
        visitorName: this.bookingInfo.guestName,
        reservationDate: this.$moment(this.bookingInfo.reservationDate).format('YYYY-MM-DD').toString(),
        reservationTime: this.bookingInfo.reservationTime,
        visitorRequests: this.bookingInfo.wishComment,
        adultHeadcount: this.bookingInfo.adultCount,
        childHeadcount: this.bookingInfo.childCount,
        babyHeadcount: this.bookingInfo.babyCount,
      }

      this.$http.post(reqUrl, params, {
        headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
      }).then(res =>{
        if(res.data.code ==="OK"){
          alert("예약수정이 완료되었습니다.")
          this.$router.go(0)
        }else{
          throw 400
        }
      }).catch(err =>{
        alert(err.response.data.message)
      })


    },
    updateBooking(){

      const reqUrl = api.changeAPI(this.siteName,api.basicURL + api.order.updateFreeBooking)
      var params = {
        bookingNo: this.bookingInfo.bookingNo,
        visitorName: this.bookingInfo.guestName,
        reservationDate: this.$moment(this.bookingInfo.reservationDate).format('YYYY-MM-DD').toString(),
        reservationTime: this.bookingInfo.reservationTime,
        visitorRequests: this.bookingInfo.wishComment,
        adultHeadcount: this.bookingInfo.adultCount,
        childHeadcount: this.bookingInfo.childCount,
        visitorPhone: this.bookingInfo.phoneNumber,
        babyHeadcount: this.bookingInfo.babyCount,
      }

      this.$http.post(reqUrl, params, {
        headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
      }).then(res =>{
        if(res.data.code ==="OK"){
          alert("예약수정이 완료되었습니다.")
          this.$router.go(0)
        }else{
          throw 400
        }
      }).catch(err =>{
        alert(err.response.data.message)
      })

    },
    // getlistFlag(){
    //
    //   if(this.listFlag == true){
    //     this.listFlag = false
    //   }else{
    //     this.listFlag = true;
    //   }
    //
    //
    // },
    bookingComplete(){

      if (this.currentUser.userRole == 'STORE_MANAGER') {
        var reqUrl = api.changeAPI(this.siteName,api.basicURL + api.order.createFreeBookingStr)
        var params = {
          visitorName: this.bookingInfo.guestName,
          reservationDate: this.$moment(this.bookingInfo.reservationDate).format('YYYY-MM-DD').toString(),
          reservationTime: this.bookingInfo.reservationTime,
          visitorRequests: this.bookingInfo.wishComment,
          adultHeadcount: this.bookingInfo.adultCount,
          childHeadcount: this.bookingInfo.childCount,
          babyHeadcount: this.bookingInfo.babyCount,
          visitorPhone: this.bookingInfo.phoneNumber
        }
      }
      if (this.currentUser.userRole == 'BRAND_ADMIN'){
        var reqUrl = api.changeAPI(this.siteName,api.basicURL + api.order.createFreeBooking)
        var params = {
          storeCode: this.bookingInfo.selectedStore,
          visitorName: this.bookingInfo.guestName,
          reservationDate: this.$moment(this.bookingInfo.reservationDate).format('YYYY-MM-DD').toString(),
          reservationTime: this.bookingInfo.reservationTime,
          visitorRequests: this.bookingInfo.wishComment,
          adultHeadcount: this.bookingInfo.adultCount,
          childHeadcount: this.bookingInfo.childCount,
          babyHeadcount: this.bookingInfo.babyCount,
          visitorPhone: this.bookingInfo.phoneNumber
        }
      }
      this.$http.post(reqUrl, params, {
        headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
      }).then(res =>{
        if(res.data.code ==="OK"){
          alert("예약접수가 완료되었습니다.")
          this.$router.go(0)
          // this.hideModal()
        }else{
          throw 400
        }
      }).catch(err =>{
        alert(err.response.data.message)
      })



    },
    hideModal(){
      this.$root.$emit('bv::hide::modal','callReservationCheck')

    },
    setUpdateBookingNo(val){
      this.bookingInfo.bookingNo = val
    },
    checkUpdate(){
      if(this.status == true){
      this.bookingInfo.bookingNo = ''
      }
    },
  },



}


</script>

<style>
.vuetable.forCheck table tr td {
  line-height: 24px;
}
.modalFontSize {
  font-size: 0.9rem !important;
}


</style>




